import { render, staticRenderFns } from "./LocaleNew.vue?vue&type=template&id=f410f792&"
import script from "./LocaleNew.vue?vue&type=script&lang=js&"
export * from "./LocaleNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports